module.exports = __webpack_public_path__ + "img/car_middle_red.fc3b62a1.png";